export function formWidgetSetPowerMVCGo1(state,msgObj){
  /***执行方法--开始***/
  const _widgerFunTo = ((resArr)=>{
    resArr.forEach((el)=>{
      if(el.type==='details'||el.type==='new-rel-radio'){
        _widgerFunTo(el.list);
      }else {
        if(el.Isper===1){
          state.formWidgetPowerSetDataTitle.editIsArr.push(el.title);
        }else if(el.Isper===2){
          state.formWidgetPowerSetDataTitle.readOnly.push(el.title);
        }else if(el.Isper===3){
          state.formWidgetPowerSetDataTitle.lookHide.push(el.title);
        }
        //告知
        if(msgObj.isCtoCo===2){
          if(el.per){
            state.formWidgetPowerSetDataTitle.isShowArr.push(el.title);
          }else {
            state.formWidgetPowerSetDataTitle.lookHide.push(el.title);
          }
        }
        if(!el.Isprint){
          state.formWidgetPowerSetDataTitle.printArr.push(el.title);
        }
      }
    });
  });
  /***执行方法--结束***/
    //流程
  const WidgerS = state.formWidgetDataPower;
  _widgerFunTo(WidgerS);
  //判断状态
  const titleArr = state.formWidgetPowerSetDataTitle;
  const powerState = state.formWidgetPowerSetStateObj;
  let widgetLent = titleArr.editIsArr.length+titleArr.readOnly.length+titleArr.lookHide.length;
  if(msgObj.isCtoCo===2){
     widgetLent = titleArr.isShowArr.length+titleArr.lookHide.length;
  }
  //告知
  if(msgObj.isCtoCo===2){
    if(titleArr.isShowArr.length===widgetLent){
      powerState.isShow = true;
    }else {
      powerState.isShow = false;
    }
  }else {
    if(titleArr.editIsArr.length===widgetLent){
      powerState.isEdit = true;
      powerState.isRead = false;
      powerState.isHide = false;
    }else if(titleArr.readOnly.length===widgetLent){
      powerState.isRead = true;
      powerState.isEdit = false;
      powerState.isHide = false;
    }else if(titleArr.lookHide.length===widgetLent){
      powerState.isHide = true;
      powerState.isEdit = false;
      powerState.isRead = false;
    }else {
      powerState.isEdit = false;
      powerState.isRead = false;
      powerState.isHide = false;
    }
  }
  if(titleArr.printArr.length===0){
    powerState.isPrin = true;
  }else {
    powerState.isPrin = false;
  }
 //powerState.isShow = !powerState.isShow;
}
